module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/pre_annotation_llm-05a91f2c3ac89bb8c3309940dd31e8e8.svg";